import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth debe ser usado dentro de un AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [lider, setLider] = useState(null);
  const [empleados, setEmpleados] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Verificar si hay datos de sesión almacenados
    const storedLider = localStorage.getItem('lider');
    const storedEmpleados = localStorage.getItem('empleados');

    if (storedLider && storedEmpleados) {
      setLider(JSON.parse(storedLider));
      setEmpleados(JSON.parse(storedEmpleados));
    }
    
    setIsLoading(false);
  }, []);

  const loginLider = (liderData, empleadosData) => {
    setLider(liderData);
    setEmpleados(empleadosData);
    
    // Almacenar en localStorage
    localStorage.setItem('lider', JSON.stringify(liderData));
    localStorage.setItem('empleados', JSON.stringify(empleadosData));
  };

  const logoutLider = () => {
    setLider(null);
    setEmpleados([]);
    
    // Limpiar localStorage
    localStorage.removeItem('lider');
    localStorage.removeItem('empleados');
  };

  const isAuthenticated = () => {
    return !!lider;
  };

  const value = {
    lider,
    empleados,
    isLoading,
    loginLider,
    logoutLider,
    isAuthenticated
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};